import axios from "axios";
import { tokenState } from "@/auth";
import { interceptInsertAuthToken } from "./interceptors";

// API Configuration
export const API_BASE_URL = `https://alto-cero-backend-multi-property-fwh3d3cybgdrdke5.southeastasia-01.azurewebsites.net/api`
// const host = window.location.hostname;
// export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ||
//   `${window.location.protocol}//${host}/api`;

// Create axios instance with default config
export const api = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
		// Authorization header will be added by interceptor
		Accept: "*/*",
		crossDomain: true,
	},
	// Add any other default configurations here
	timeout: 10000, // 10 seconds
});
interceptInsertAuthToken(api);

// Response interceptor for error handling
api.interceptors.response.use(
	(response) => response.data,
	(error) => {
		if (error.response) {
			// Check for "Invalid token" in error response
			const errorDetail = error.response.data?.detail;
			const isInvalidToken = errorDetail === "Invalid token." || errorDetail === "Invalid token";
			
			if (isInvalidToken) {
				// Clear tokens and redirect to login
				tokenState.clearTokens();
				window.location.href = "/login";
				return Promise.reject(error);
			}
			
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx
			throw new ApiError(
				error.response.data.message || "Server error",
				error.response.status,
				error.response.data
			);
		} else if (error.request) {
			// The request was made but no response was received
			throw new ApiError("No response from server");
		} else {
			// Something happened in setting up the request that triggered an Error
			throw new ApiError(error.message);
		}
	}
);

// API endpoints
export const ENDPOINTS = {
  AUTOPILOT: '/autopilot/',
  AUTOPILOT_GEARS: '/autopilot_gears/',
  EVENTLOG: '/automation_logs/grouped/',
  DEVICES: '/systems/ac_subsystem/',
  MANUAL_CONTROL: '/manual-control/',
  ZONES: '/zones/',
  SOLAR: '/systems/solar_subsystem/',
  CAMERA: '/systems/cctv_subsystem/',
  IAQ: '/systems/iaq_subsystem/',
  PMV: '/pmv_variables/',
  PMVMETRIC: '/pmv_physical_metrics/',
  PROFILES: '/profiles/',
  CALENDAR: '/calendars/',
  AUTOMATIONS: '/automations/',
  BLUEPRINTS: '/blueprints/',
  SITES: '/sites/',
} as const;

// API response types
export interface ApiResponse<T> {
	success: boolean;
	status: number;
	message: string;
	metadata: {
		timestamp: string;
		version: string;
		type: string;
	};
	pagination: {
		total: number;
		page: number;
		per_page: number;
		total_pages: number;
	};
	data: T;
}

// Error handling
export class ApiError extends Error {
	constructor(
		message: string,
		public status?: number,
		public data?: unknown
	) {
		super(message);
		this.name = "ApiError";
	}
}
